jQuery(function ($) {
    if ( $('.shindan').length ) {
        let question_num = 1;

        //ラジオボタンのチェックを全て外す
        $('input[type="radio"]').prop('checked',false);

        //ラジオボタン変更時の処理
        $('.shindan__answer-radio').on('change',function(){
            console.log('hogehoge');
            $(this).parent().find('.shindan__answer').removeClass('is-select');
            $(this).next().addClass('is-select');
            //console.log('ラジオボタン1:' + $('input[name="question1"]:checked').val());
            //console.log('ラジオボタン2:' + $('input[name="question2"]:checked').val());
            //console.log('ラジオボタン3:' + $('input[name="question3"]:checked').val());
            $('.shindan__button-item:nth-child(' + question_num + ') .shindan__button.is-next').prop('disabled',false);
            $('.shindan__button-item:nth-child(' + question_num + ') .shindan__button.is-complete').prop('disabled',false);
        });

        if ( !$('.shindan').hasClass('is-top-page') ) {
            //ページ切り替え処理
            function set_question_page(num) {
                $('.shindan__question-num').fadeOut();
                $('.shindan__question-item').fadeOut();
                $('.shindan__button-item').hide();
                if ( num === 1 ) {
                    $('.shindan__body').addClass('is-1st');
                } else {
                    $('.shindan__body').removeClass('is-1st');
                }
                $('.shindan__question-num:nth-child(' + num + ')').fadeIn('slow');
                $('.shindan__question-item:nth-child(' + num + ')').fadeIn('slow');
                $('.shindan__button-item:nth-child(' + num + ')').fadeIn('slow');
                if ( num === 1 ) {
                    $('.shindan__body').addClass('is-1st');
                } else {
                    $('.shindan__body').removeClass('is-1st');
                }
                question_num = num;
            }
            //次へボタンクリック時の処理
            $('.shindan__button.is-next').on('click',function(){
                set_question_page( question_num + 1 );
            });
            //戻るボタンクリック時の処理
            $('.shindan__button.is-prev').on('click',function(){
                set_question_page( question_num - 1 );
            });
            //結果を見るボタンクリック時の処理
            $('.shindan__button.is-complete').on('click',function(){
                let key = $('input[name="question1"]:checked').val() + $('input[name="question2"]:checked').val() + $('input[name="question3"]:checked').val();
                let href = $(this).attr('data-href');
                let param = '?program-diagnose-key=';
                if ( key.length == 3 ) {
                    param = param + key;
                    window.location.href = href + param;
                }
            });
    
            //1問目の回答をトップページから引き継いでくる場合の処理
            let current_url = new URL(window.location.href);
            let current_params = current_url.searchParams;
            if ( current_params.get('question1') > 0 ) {
                console.log('question1=' + current_params.get('question1'));
                let question1 = current_params.get('question1');
                let element_selector = '#question1-' + question1;
                if ( $(element_selector).length ) {
                    $(element_selector).get(0).checked = true;
                    $(element_selector).next().addClass('is-select');
                    $('.shindan__button-item:nth-child(1) .shindan__button.is-next').prop('disabled',false);
                    question_num ++;
                }
            }
            set_question_page(question_num);

        }
    }
});